import React from 'react';
import { Controls } from '../../../components';
import { IconCheckmarkStrongL, IconCopyL, IconTrashL } from '../../../icons';
import css from './MessageControl.css';
import classNames from 'classnames';
import { useMessageContext, CONTROLS_PANEL_ATTR } from './useMessageContext';

const MessageControl = ({ controlsPanelOpen, handleControlsVisibility, rootClassName }) => {
    const {
        copied,
        copyToClickBoard,
        message,
        deleteMessageAllowed,
        handleMessageDeleting,
    } = useMessageContext();

    const { attributes } = message || {};
    const { content } = attributes || {};

    return (
        <Controls
            rootClassName={classNames(css.root, rootClassName)}
            tooltipClassName={css.tooltipContent}
            isOpened={controlsPanelOpen}
            handleToggle={() => handleControlsVisibility(!controlsPanelOpen)}
            controlHolderProps={{
                outsideClickHandler: () => handleControlsVisibility(false),
                [CONTROLS_PANEL_ATTR]: 'true',
            }}
            menu={
                <Controls.Menu>
                    <Controls.Item
                        onClick={e => {
                            e && e.stopPropagation();
                            copyToClickBoard(content);
                        }}
                        icon={copied ? <IconCheckmarkStrongL /> : <IconCopyL />}
                    >
                        Kopieren
                    </Controls.Item>
                    {deleteMessageAllowed && (
                        <Controls.Item icon={<IconTrashL />} onClick={handleMessageDeleting}>
                            Löschen
                        </Controls.Item>
                    )}
                </Controls.Menu>
            }
        >
            <Controls.Trigger
                className={css.controlTrigger}
                onMouseDown={e => e.preventDefault()}
            />
        </Controls>
    );
};
export default MessageControl;
